import jwtAuthService from '../../services/jwtAuthService';
import { setUserData } from './UserActions';
import history from 'history.js';

export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR_CLEAR = 'LOGIN_ERROR_CLEAR';

export const loginErrorClear = () => {
  return {
    type: LOGIN_ERROR_CLEAR
  };
};

export function loginWithUsernameAndPassword({ username, password }) {
  return dispatch => {
    jwtAuthService
      .loginWithUsernameAndPassword(username, password)
      .then(user => {
        dispatch(setUserData(user));

        if (user && user.terms) {
          if (user.terms.accepted !== 'Y') {
            history.push({ pathname: '/session/terms' });
          } else {
            history.push({ pathname: '/' });
          }
        } else {
          history.push({ pathname: '/' });
        }

        return dispatch({
          type: LOGIN_SUCCESS
        });
      })
      .catch(error => {
        return dispatch({
          type: LOGIN_ERROR,
          payload: error.response.data
        });
      });
  };
}
